import { render, staticRenderFns } from "./collect-cards-popup.vue?vue&type=template&id=6881de60&scoped=true&"
import script from "./collect-cards-popup.vue?vue&type=script&lang=js&"
export * from "./collect-cards-popup.vue?vue&type=script&lang=js&"
import style0 from "./collect-cards-popup.vue?vue&type=style&index=0&id=6881de60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6881de60",
  null
  
)

export default component.exports